module.exports = __webpack_public_path__ + "static/media/00-_DSC7578.253924a9.jpg";